import React from 'react';
import NameDefinition from './NameDefinition';
import PropTypes from 'prop-types';

const CpcDefinition = ({
  textFormat = 'text-xs font-semibold w-fit text-background-dark',
  definition = 'Cost Per Click',
  size,
}) => {
  return <NameDefinition name='CPC' definition={definition} textSize={textFormat} size={size} />;
};

export default CpcDefinition;

CpcDefinition.propTypes = {
  textFormat: PropTypes.string,
};
